import { BackendMessagesNL } from './backendMessagesNL';
import buildingNL from './messages/building.json';
import dashboardCustomizeNL from './messages/dashboard/customize.json';
import dashboardCustomTabsNL from './messages/dashboard/customTabs.json';
import dashboardNL from './messages/dashboard/dashboard.json';
import dashboardWidgetLibraryNL from './messages/dashboard/widgetLibrary.json';
import dashboardWidgetsNL from './messages/dashboard/widgets.json';
import invoiceLifecycleNL from './messages/invoiceLifecycle.json';
import leaseInventoryNL from './messages/leaseInventory.json';
import propertySiteNL from './messages/propertySite.json';
import tagNL from './messages/tag.json';
import technicNL from './messages/technic.json';
import ticketsNL from './messages/tickets.json';

export const MessagesNL = {
  ...BackendMessagesNL,
  building: buildingNL,
  dashboard: {
    ...dashboardNL,
    widgets: dashboardWidgetsNL,
    widgetLibrary: dashboardWidgetLibraryNL,
    customize: dashboardCustomizeNL,
    customTabs: dashboardCustomTabsNL,
  },
  invoiceLifecycle: invoiceLifecycleNL,
  leaseInventory: leaseInventoryNL,
  propertySite: propertySiteNL,
  tag: tagNL,
  technic: technicNL,
  tickets: ticketsNL,
};
